import authGroupMockupData from './mock/authGroup.json'
import menuGroupMockupData from './mock/menuGroup.json'
import menuInMenuGroupMockupData from './mock/menuInMenuGroup.json'
import userGroupMockupData from './mock/userGroup.json'
import authGroupManagerData from './mock/authGroupManager.json'
import taskClassificationData from './mock/taskClassification.json'
import privilegeGroupData from './mock/privilegeGroup.json'
import expandAuthData from './mock/expandAuthList.json'
import groupIdData from './mock/groupId.json'
import groupNameData from './mock/groupName.json'
import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'
import axios from 'axios'
import envs from '../../../envs.js'

// 사용자그룹 메뉴 그룹 연결 정보 조회 API
export function getAuthGroups(inputData) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: `/hiway/auth/group/${inputData.usergroup_id}`,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    var success = authGroupMockupData
    if (inputData) {
      // 선택된 usergroup_id 가 있을 경우 해당 id와 같은 usergroup_id 를 가진 menugorup만 조회
      success = authGroupMockupData.filter(authGroup => {
        return authGroup.usergroup_id === inputData.usergroup_id
      })
    }
    resolve(success)
  })
}

// 사용자 그룹에 메뉴 그룹 연결 등록 및 삭제
export function saveMenuGroupInUserGroup(gridSaveDatas) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    var saveActions = []
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var createdAction = function(rowDatas) {
      // row 값을 보내 추가 처리
      return request({
        url: '/auth/group',
        method: 'post',
        data: rowDatas
      })
    }
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var deletedAction = function(rowDatas) {
      // row 값을 보내 삭제 처리
      return request({
        url: '/auth/group',
        method: 'delete',
        data: rowDatas
      })
    }
    // created 에 담긴 데이터가 있으면, request post 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.created && gridSaveDatas.created.length > 0) {
      saveActions.push(createdAction(gridSaveDatas.created))
    }
    // deleted 에 담긴 데이터가 있으면, request delete 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.deleted && gridSaveDatas.deleted.length > 0) {
      saveActions.push(deletedAction(gridSaveDatas.deleted))
    }
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    // axios.all 을 사용하면 post, delete, put을 한꺼번에 처리 가능하다.
    // 하나하나씩 따로 보내서 처리할경우 리턴 값을 각각 받아야해서 한번에 보내 처리한다.
    return (
      axios
        .all(saveActions)
        // saveActions에 담긴 요청이 전부 성공하면 200 을 던져준다
        .then(response => {
          return response
        })
        .catch(error => {
          // saveActions에 담긴 요청이 하나라도 실패하면 에러를 던져준다
          return error
        })
    )
  }

  // restful api를 사용하지 않을 경우
  // 성공으로 200 코드를 넘긴다.
  return new Promise(function(resolve, reject) {
    resolve('200')
  })
}

// 사용자그룹 정보 조회 API
export function getUserGroups() {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/hiway/auth/usergroup',
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    var usergroupList = userGroupMockupData.filter(function(userGroup, index) {
      return userGroup.subcode === '*'
    })
    resolve(usergroupList)
  })
}

// 사용자그룹 내 사용자 정보 조회 API
export function getUserInUserGroup(inptData) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/hiway/auth/usergroup/' + inptData.usergroup_id,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    var userList = userGroupMockupData.filter(function(userGroup, index) {
      if (userGroup.subcode === '*') {
        return false
      } else {
        return userGroup.code === inptData.code
      }
    })
    resolve(userList)
  })
}

// 사용자 그룹 등록,수정,삭제
export function saveUserGroup(gridSaveDatas) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    var saveActions = []
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var createdAction = function(rowDatas) {
      // row 값을 보내 추가 처리
      return request({
        url: '/hiway/auth/usergroup',
        method: 'post',
        data: rowDatas
      })
    }
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var updatedAction = function(rowDatas) {
      // row 값을 보내 추가 처리
      return request({
        url: '/hiway/auth/usergroup',
        method: 'put',
        data: rowDatas
      })
    }
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var deletedAction = function(rowDatas) {
      // row 값을 보내 삭제 처리
      return request({
        url: '/hiway/auth/usergroup',
        method: 'delete',
        data: rowDatas
      })
    }
    // created 에 담긴 데이터가 있으면, request post 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.created && gridSaveDatas.created.length > 0) {
      saveActions.push(createdAction(gridSaveDatas.created))
    }
    // updated 에 담긴 데이터가 있으면, request put 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.updated && gridSaveDatas.updated.length > 0) {
      saveActions.push(updatedAction(gridSaveDatas.updated))
    }
    // deleted 에 담긴 데이터가 있으면, request delete 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.deleted && gridSaveDatas.deleted.length > 0) {
      saveActions.push(deletedAction(gridSaveDatas.deleted))
    }
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    // axios.all 을 사용하면 post, delete, put을 한꺼번에 처리 가능하다.
    // 하나하나씩 따로 보내서 처리할경우 리턴 값을 각각 받아야해서 한번에 보내 처리한다.
    return (
      axios
        .all(saveActions)
        // saveActions에 담긴 요청이 전부 성공하면 200 을 던져준다
        .then(response => {
          return response
        })
        .catch(error => {
          // saveActions에 담긴 요청이 하나라도 실패하면 에러를 던져준다
          return error
        })
    )
  }

  // restful api를 사용하지 않을 경우
  // 성공으로 200 코드를 넘긴다.
  return new Promise(function(resolve, reject) {
    resolve('200')
  })
}

// 사용자 그룹에 사용자 등록 및 삭제
export function saveUserInUserGroup(gridSaveDatas) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    var saveActions = []
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var createdAction = function(rowDatas) {
      // row 값을 보내 추가 처리
      return request({
        url: '/hiway/auth/usergroup/user',
        method: 'post',
        data: rowDatas
      })
    }
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var deletedAction = function(rowDatas) {
      // row 값을 보내 삭제 처리
      return request({
        url: '/hiway/auth/usergroup/user',
        method: 'delete',
        data: rowDatas
      })
    }
    // created 에 담긴 데이터가 있으면, request post 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.created && gridSaveDatas.created.length > 0) {
      saveActions.push(createdAction(gridSaveDatas.created))
    }
    // deleted 에 담긴 데이터가 있으면, request delete 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.deleted && gridSaveDatas.deleted.length > 0) {
      saveActions.push(deletedAction(gridSaveDatas.deleted))
    }
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    // axios.all 을 사용하면 post, delete, put을 한꺼번에 처리 가능하다.
    // 하나하나씩 따로 보내서 처리할경우 리턴 값을 각각 받아야해서 한번에 보내 처리한다.
    return (
      axios
        .all(saveActions)
        // saveActions에 담긴 요청이 전부 성공하면 200 을 던져준다
        .then(response => {
          return response
        })
        .catch(error => {
          // saveActions에 담긴 요청이 하나라도 실패하면 에러를 던져준다
          return error
        })
    )
  }

  // restful api를 사용하지 않을 경우
  // 성공으로 200 코드를 넘긴다.
  return new Promise(function(resolve, reject) {
    resolve('200')
  })
}

// 메뉴그룹 정보 조회 API
export function getMenuGroups() {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/hiway/auth/menugroup',
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(menuGroupMockupData)
  })
}

// 메뉴그룹 내 메뉴 정보 조회 API
export function getMenuInMenuGroup(inptData) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    return request({
      url: '/hiway/auth/menugroup/tree/' + inptData.menugroup_id,
      method: 'get'
    })
  }

  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    // cloneDeep 을 사용하는 이유는 데이터를 그냥 보낼 경우 조회를 할 때마다 데이터가 늘어나는 현상이 있어서임
    resolve(_.cloneDeep(menuInMenuGroupMockupData))
  })
}

// 메뉴 그룹 등록,수정,삭제
export function saveMenuGroup(gridSaveDatas) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    var saveActions = []
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var createdAction = function(rowDatas) {
      // row 값을 보내 추가 처리
      return request({
        url: '/hiway/auth/menugroup',
        method: 'post',
        data: rowDatas
      })
    }
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var updatedAction = function(rowDatas) {
      // row 값을 보내 추가 처리
      return request({
        url: '/hiway/auth/menugroup/menu',
        method: 'put',
        data: rowDatas
      })
    }
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var deletedAction = function(rowDatas) {
      // row 값을 보내 삭제 처리
      return request({
        url: '/hiway/auth/menugroup',
        method: 'delete',
        data: rowDatas
      })
    }
    // created 에 담긴 데이터가 있으면, request post 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.created && gridSaveDatas.created.length > 0) {
      saveActions.push(createdAction(gridSaveDatas.created))
    }
    // updated 에 담긴 데이터가 있으면, request put 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.updated && gridSaveDatas.updated.length > 0) {
      saveActions.push(updatedAction(gridSaveDatas.updated))
    }
    // deleted 에 담긴 데이터가 있으면, request delete 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.deleted && gridSaveDatas.deleted.length > 0) {
      saveActions.push(deletedAction(gridSaveDatas.deleted))
    }
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    // axios.all 을 사용하면 post, delete, put을 한꺼번에 처리 가능하다.
    // 하나하나씩 따로 보내서 처리할경우 리턴 값을 각각 받아야해서 한번에 보내 처리한다.
    return (
      axios
        .all(saveActions)
        // saveActions에 담긴 요청이 전부 성공하면 200 을 던져준다
        .then(response => {
          return response
        })
        .catch(error => {
          // saveActions에 담긴 요청이 하나라도 실패하면 에러를 던져준다
          return error
        })
    )
  }

  // restful api를 사용하지 않을 경우
  // 성공으로 200 코드를 넘긴다.
  return new Promise(function(resolve, reject) {
    resolve('200')
  })
}

// 메뉴 그룹에 메뉴 등록 및 삭제
export function saveMenuInMenuGroup(gridSaveDatas) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    var saveActions = []
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var createdAction = function(rowDatas) {
      // row 값을 보내 추가 처리
      return request({
        url: '/hiway/auth/menugroup/menu',
        method: 'post',
        data: rowDatas
      })
    }
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var updatedAction = function(rowDatas) {
      // row 값을 보내 삭제 처리
      return request({
        url: '/hiway/auth/menugroup/menu',
        method: 'put',
        data: rowDatas
      })
    }
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var deletedAction = function(rowDatas) {
      // row 값을 보내 삭제 처리
      return request({
        url: '/hiway/auth/menugroup/menu',
        method: 'delete',
        data: rowDatas
      })
    }
    // created 에 담긴 데이터가 있으면, request post 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.created && gridSaveDatas.created.length > 0) {
      saveActions.push(createdAction(gridSaveDatas.created))
    }
    // updated 에 담긴 데이터가 있으면, request put 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.updated && gridSaveDatas.updated.length > 0) {
      saveActions.push(updatedAction(gridSaveDatas.updated))
    }
    // deleted 에 담긴 데이터가 있으면, request delete 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.deleted && gridSaveDatas.deleted.length > 0) {
      saveActions.push(deletedAction(gridSaveDatas.deleted))
    }
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    // axios.all 을 사용하면 post, delete, put을 한꺼번에 처리 가능하다.
    // 하나하나씩 따로 보내서 처리할경우 리턴 값을 각각 받아야해서 한번에 보내 처리한다.
    return (
      axios
        .all(saveActions)
        // saveActions에 담긴 요청이 전부 성공하면 200 을 던져준다
        .then(response => {
          return response
        })
        .catch(error => {
          // saveActions에 담긴 요청이 하나라도 실패하면 에러를 던져준다
          return error
        })
    )
  }

  // restful api를 사용하지 않을 경우
  // 성공으로 200 코드를 넘긴다.
  return new Promise(function(resolve, reject) {
    resolve('200')
  })
}

// 권한그룹관리 업무구분 셀렉트박스 조회
export function getClassification() {
  if (isUseAPI(false)) {
    return request({
      url: '/hiway/classification',
      method: 'get'
    })
  }

  return new Promise(function(resolve, reject) {
    resolve(taskClassificationData)
  })
}

// 권한그룹관리 권한그룹유형 조회 groupName
export function getGroupNameData() {
  if (isUseAPI(false)) {
    return request({
      url: '/hiway/group/name',
      method: 'get'
    })
  }

  return new Promise(function(resolve, reject) {
    resolve(groupNameData)
  })
}

// 권한그룹관리 목록 조회
export function getAuthGroupManagert(retrieveObj) {
  return request({
    url: `/hiway/authgroups/apps/${retrieveObj.app_id}`,
    method: 'get',
    meta: { apiVersion: '2.0.0' },
    params: retrieveObj
  })
}
// 권한그룹 목록 조회
export function getPrivilegeGroupData(retrieveObj) {
  if (isUseAPI()) {
    return request({
      url: `/hiway/authgroups/${retrieveObj.app_id}/${retrieveObj.authgrp_cd}?authgrp_nm=${retrieveObj.authgrp_nm}`,
      method: 'get'
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    var res = privilegeGroupData
    res = res.filter(item => {
      return (
        item.authgrp_cd.includes(retrieveObj.authgrp_cd) &&
        item.authgrp_nm.includes(retrieveObj.authgrp_nm)
      )
    })
    resolve(res)
  })
}

// 권한그룹 목록 조회
export function getGroupIdData(retrieveObj) {
  if (isUseAPI()) {
    return request({
      url: `/hiway/menuauths/${retrieveObj.app_id}/${retrieveObj.authgrp_cd}/${retrieveObj.menu_id}`,
      method: 'get'
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    var res = groupIdData[retrieveObj.authgrp_cd]
    if (!res) {
      res = groupIdData['all']
    }
    resolve(res)
  })
}

export function getAuthGroup(retrieveObj) {
  if (isUseAPI()) {
    let url = `/hiway/authgroups/apps/${envs.systemId}`
    let params = {}

    if (retrieveObj.app_id) url = `/hiway/authgroups/apps/${retrieveObj.app_id}`
    if (retrieveObj.authgrp_cd) params = { authgrp_cd: retrieveObj.authgrp_cd }
    if (retrieveObj.authgrp_nm) params = { authgrp_nm: retrieveObj.authgrp_nm }
    if (retrieveObj.authgrp_nm && retrieveObj.authgrp_cd) {
      params = {
        authgrp_nm: retrieveObj.authgrp_nm,
        authgrp_cd: retrieveObj.authgrp_cd
      }
    }
    return request({
      url,
      method: 'get',
      params,
      meta: { apiVersion: '2.0.0' }
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(authGroupManagerData)
  })
}

// 시스템별 확장 권한 리스트 조회
export function getAppExpandAuthList(retrieveObj) {
  return request({
    url: `/hiway/extauths/apps/${retrieveObj.app_id}`,
    params: retrieveObj,
    meta: { apiVersion: '2.0.0' },
    method: 'get'
  })
}

// 확장 권한 리스트 조회
export function getExpandAuthList(retrieveObj) {
  if (isUseAPI()) {
    return request({
      // url: `/hiway/extauths/${retrieveObj.app_id}/${retrieveObj.exauth_id}`,
      url: `/hiway/extauths/apps/${envs.systemId}?exauth_id=${retrieveObj.exauth_id}&exauth_nm=${retrieveObj.exauth_nm}`,
      method: 'get',
      meta: { apiVersion: '2.0.0' }
    })
  }
  // restful api를 사용하지 않을 경우
  return new Promise(function(resolve, reject) {
    resolve(expandAuthData)
  })
}

export function saveExpandAuthList(saveDataSet) {
  // 각각 데이터들은 상태에 따라 created, updated, deleted에 들어간다.
  // 각 Array 형태로 셋팅되어 있으며, 각 row 별 app_id와 pgm_id 들이 들어가 있다.
  if (isUseAPI()) {
    return request({
      url: `/hiway/extauths/apps/${envs.systemId}`,
      method: 'post',
      data: saveDataSet,
      meta: { apiVersion: '2.0.0' }
    })
  }

  return new Promise(function(resolve, reject) {
    resolve()
  })
}
export function deleteExAuth(deleteDataSet) {
  // 각각 데이터들은 상태에 따라 created, updated, deleted에 들어간다.
  // 각 Array 형태로 셋팅되어 있으며, 각 row 별 app_id와 pgm_id 들이 들어가 있다.
  if (isUseAPI()) {
    return request({
      url: `/hiway/extauths/apps/${envs.systemId}`,
      method: 'delete',
      data: deleteDataSet,
      meta: { apiVersion: '2.0.0' }
    })
  }

  return new Promise(function(resolve, reject) {
    resolve(getResultObj(deleteDataSet.deleted.length))
  })
}
// 메뉴 그룹에 메뉴 등록 및 삭제
export function saveGroupMenuData(gridSaveDatas) {
  // local 개발 환경이 아닐 경우, 무조건 서버를 조회해야 함
  if (isUseAPI()) {
    var saveActions = []
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var createdAction = function(rowDatas) {
      // row 값을 보내 추가 처리
      return request({
        url: `/hiway/menuauths/${gridSaveDatas.retrieveData.app_id}`,
        method: 'post',
        data: rowDatas
      })
    }
    // 한번에 보내서 처리하기 위해 필요한 정보들을 형식에 맞게 담아준다.
    var deletedAction = function(rowDatas) {
      // row 값을 보내 삭제 처리
      return request({
        url: '/hiway/menuauths/delete',
        method: 'delete',
        data: rowDatas
      })
    }
    // created 에 담긴 데이터가 있으면, request post 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.created && gridSaveDatas.created.length > 0) {
      saveActions.push(createdAction(gridSaveDatas.created))
    }
    // deleted 에 담긴 데이터가 있으면, request delete 틀에 맞춰 만들어준다
    // 전체 데이터를 배열로 담아 넘긴다
    if (gridSaveDatas.deleted && gridSaveDatas.deleted.length > 0) {
      saveActions.push(deletedAction(gridSaveDatas.deleted))
    }
    // 차후 변경될 Restful 형식에 따라 수정해야 함
    // axios.all 을 사용하면 post, delete, put을 한꺼번에 처리 가능하다.
    // 하나하나씩 따로 보내서 처리할경우 리턴 값을 각각 받아야해서 한번에 보내 처리한다.
    return (
      axios
        .all(saveActions)
        // saveActions에 담긴 요청이 전부 성공하면 200 을 던져준다
        .then(response => {
          return response
        })
        .catch(error => {
          // saveActions에 담긴 요청이 하나라도 실패하면 에러를 던져준다
          return error
        })
    )
  }

  // restful api를 사용하지 않을 경우
  // 성공으로 200 코드를 넘긴다.
  return new Promise(function(resolve, reject) {
    resolve('200')
  })
}

// 권한그룹 리스트를 저장한다.
export function saveAuthGroupList(saveDataSet) {
  let sRowData = {}
  if (saveDataSet.created.length > 0) {
    sRowData = saveDataSet.created[0]
  } else if (saveDataSet.updated.length > 0) {
    sRowData = saveDataSet.updated[0]
  }

  return request({
    // url: '/hiway/authgroups',
    url: `/hiway/authgroups/apps/${sRowData.app_id}`,
    method: 'post',
    meta: { apiVersion: '2.0.0' },
    data: saveDataSet
  })
}

export function deleteAuthGroupList(saveDataSet) {
  let sRowData = saveDataSet.deleted[0]

  return request({
    // url: '/hiway/authgroups',
    url: `/hiway/authgroups/apps/${sRowData.app_id}`,
    method: 'delete',
    meta: { apiVersion: '2.0.0' },
    data: saveDataSet
  })
}

function getResultObj(count) {
  let total = count
  let s = _.random(0, total)
  let f = total - s
  let e = _.random(100, 999)
  return {
    result: {
      total: {
        count: total,
        success: s,
        fail: f
      },
      execTime: e,
      resMsg: `${total}건 중, ${s}건 성공, ${f}건 실패. ${e}ms`
    }
  }
}
